import React, { FC } from "react"

interface DetailHeaderProps {
  headerText: string;
}

export const DetailHeader: FC<DetailHeaderProps> = ( {headerText} ) => {
  return (
    <div className='bp-mt-16 bp-mb-16'>
      <pichincha-typography weight='bold' variant="bodyText" color='darkGrey' weight_color='500'>
        {headerText}
      </pichincha-typography>
    </div>
  )
}